import React from 'react'

import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {guestPickerMessages} from './guestPickerMessages'

interface Props {
  numberOfAdults: number
  numberOfChildren: number
  numberOfRooms: number
  isRoomsLabelShown: boolean
}

/**
 * Search box guest label on the B side of the redesign, e.g. "2 rooms · 4 adults, 1 child".
 */
export const RedesignedGuestLabel = ({
  numberOfAdults,
  numberOfChildren,
  numberOfRooms,
  isRoomsLabelShown
}: Props) => (
  <FormattedMessageWrapper
    {...(isRoomsLabelShown
      ? guestPickerMessages.roomsAndGuestsDetail
      : guestPickerMessages.guestsDetail)}
    values={{numberOfAdults, numberOfChildren, numberOfRooms}}
  />
)
